// Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, ReactElement } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { Inbox as InboxIcon } from "@mui/icons-material";

interface NoDataAvailableProps {
  message?: string;
  description?: string;
}

/**
 * No Data Available component for displaying when tables have no data.
 *
 * @param {NoDataAvailableProps} props - Props injected to the component.
 * @return {React.ReactElement}
 */
export const NoDataAvailable: FunctionComponent<NoDataAvailableProps> = ({
  message = "No data available",
  description = "There are no items to display at the moment."
}): ReactElement => {
  return (
    <Paper sx={{ 
      padding: 4, 
      textAlign: 'center', 
      backgroundColor: '#fafafa',
      border: '1px dashed #e0e0e0',
      minHeight: '200px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <InboxIcon 
        sx={{ 
          fontSize: 64, 
          color: '#9e9e9e', 
          marginBottom: 2 
        }} 
      />
      <Typography 
        variant="h6" 
        sx={{ 
          color: '#757575', 
          marginBottom: 1,
          fontWeight: 500
        }}
      >
        {message}
      </Typography>
      <Typography 
        variant="body2" 
        sx={{ 
          color: '#9e9e9e',
          maxWidth: '300px'
        }}
      >
        {description}
      </Typography>
    </Paper>
  );
};

export default NoDataAvailable; 